import loadable from '@loadable/component'
import { nanoid } from 'nanoid'
import queryString from 'query-string'
import { apps } from '#/constants'
import * as Helpers from '#/helpers'

const React = require('react')
const ReactDOM = require('react-dom')

const ErrorFallback = loadable(() => import(`#/components/ErrorFallback`))
const Macro = loadable(() => import(`#/components/macro/Macro`))

// eslint-disable-next-line no-restricted-globals
const qs = queryString.parse(location.search)
const data = qs.data

try {
  const macro = JSON.parse(data)
  ReactDOM.render(
    <Macro macro={macro} isApproved />,
    document.getElementById('macro')
  )
} catch (e) {
  // is an autoconvert link
  const pastedLink = data
  const { appExtract, linkExtract } = Helpers.extractLink(pastedLink)
  const macro = {
    ...Helpers.getTheme('Electric Blue', false),
    uuid: nanoid(10),
    radius: 3,
    hide: true,
  }

  let appKey = appExtract
  appKey = Helpers.modifyAppKey(appKey, pastedLink)

  const tabs = [
    {
      id: nanoid(10),
      config: {
        title: apps[appKey].title.replace(/\s&.*$/, ''),
        app: appKey.toLowerCase(),
        icon: appKey.toLowerCase(),
        showIcon: true,
      },
      embed: {
        ...apps[appKey].embed,
        url: linkExtract,
      },
    },
  ]
  ReactDOM.render(
    <ErrorFallback>
      <Macro macro={macro} _tabs={tabs} />
    </ErrorFallback>,
    document.getElementById('macro')
  )
}
